import { Layout, Profile } from '../../../components/app';

export const ProfilePage = () => {
  return (
    <Layout>
      <Profile />
    </Layout>
  );
};
